<div class="panelDetailTerritories" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}" id="panelTerritoryContainer">
    <div *ngIf="!isLoading" class="panelDetailTerritories">

        <div class="header-panel">
            <div class="btnClose">
                <mat-icon (click)="ClosePanel()">arrow_back_ios</mat-icon>
                <!-- <img [src]="'cancelar.svg' | findUrl" (click)="ClosePanel()"> -->
            </div>
            <h3>Detalle de Territorio</h3>
            <span class="badge-locations" *ngIf="$ItemsBackup?.length > 0">{{$ItemsBackup.length}} ubicaciones</span>
        </div>

        <div class="territory-details-section" *ngIf="selectedTerritory">
            <div class="detail-card">
                <mat-icon class="detail-icon">badge</mat-icon>
                <div class="detail-content">
                    <span class="detail-label">ID TERRITORIO</span>
                    <span class="detail-value">{{ selectedTerritory.idTerritory }}</span>
                </div>
            </div>
            <div class="detail-card">
                <mat-icon class="detail-icon">location_on</mat-icon>
                <div class="detail-content">
                    <span class="detail-label">REGIÓN / ZONA</span>
                    <span class="detail-value">{{ selectedTerritory.region || 'N/A' }} / {{ selectedTerritory.zone || 'N/A' }}</span>
                </div>
            </div>
            <div class="detail-card">
                <mat-icon class="detail-icon">route</mat-icon>
                <div class="detail-content">
                    <span class="detail-label">TIPO RUTA</span>
                    <span class="detail-value">{{ selectedTerritory.routeType }}</span>
                </div>
            </div>
            <div class="detail-card">
                <mat-icon class="detail-icon">calendar_today</mat-icon>
                <div class="detail-content">
                    <span class="detail-label">DÍA / FRECUENCIA</span>
                    <span class="detail-value">{{ selectedTerritory.visitDay }} - {{ selectedTerritory.routeFrequency }}</span>
                </div>
            </div>
            <div class="detail-card">
                <mat-icon class="detail-icon">assessment</mat-icon>
                <div class="detail-content">
                    <span class="detail-label">SATURACIÓN</span>
                    <span class="detail-value" [style.color]="selectedTerritory.saturation | saturationColor">{{ selectedTerritory.saturation }}</span>
                </div>
            </div>
        </div>

        <div class="territoriesLocations-section">
            <div class="search-Arrow-flex">
                <div class="searchBar-flex">
                    <div class="searchBar" id="searchTerritoryInput" matTooltip="Buscar por Nombre"
                        matTooltipPosition="above">
                        <mat-form-field class="width-input">
                            <input #filterTerritory [(ngModel)]="finder" matInput placeholder="Búsqueda por Nombre"
                                spellcheck="false" type="text" (input)="onFindTerritoryLocation($event)" />
                        </mat-form-field>
                    </div>
                    <div class="btnResetFilter-container" (click)="resetFilterValue()" *ngIf="finder.length > 0">
                        <mat-icon matTooltip="Borrar" aria-hidden="false">cancel</mat-icon>
                    </div>
                    <div class="btnSearch-container" (click)="onFindTerritoryLocation($event)">
                        <img class="btnSearchIcon" src="/assets/img/icon_search.png" *ngIf="finder.length == 0">
                    </div>
                </div>

                <div *ngIf="!mobileQuery.matches && !fullScreen" (click)="fullScreen = !fullScreen">
                    <mat-icon class="mobile-flecha">keyboard_arrow_up</mat-icon>
                </div>
                <div *ngIf="!mobileQuery.matches && fullScreen" (click)="fullScreen = !fullScreen">
                    <mat-icon class="mobile-flecha">keyboard_arrow_down</mat-icon>
                </div>
            </div>

            <div class="territoriesLocations-list">
                <div class="locationCard" *ngFor="let item of $Items">
                    <div class="locationCard-icon" (click)="onCardClicked(item)">
                        <img [src]="'bussineLocation.png' | findUrl" width="28px">
                    </div>
                    <div class="locationCard-info" (click)="onCardClicked(item)">
                        <span class="locationCard-title">{{ item.identifier }}</span>
                        <span class="locationCard-subtitle">{{ item.description }}</span>
                    </div>
                    <!-- <div class="locationCard-delete" (click)="removeLocation(item)">
                        <mat-icon>delete</mat-icon>
                    </div> -->
                </div>
                <div class="no-results" *ngIf="$Items.length == 0 && !isLoading">
                    <span class="no-results-text">No se encontraron resultados</span>
                </div>
            </div>
        </div>
    </div>

    <div class="skeletonLoader" *ngIf="isLoading">
        <div class="panelTerrtories">
            <div class="header-panel">
                <div class="btnClose">
                    <ngx-skeleton-loader count="1" appearance="circle" [theme]="{ 'width': '24px', 'height': '24px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </div>
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '20px', 'width': '100px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '12px', 'height': '24px', 'width': '100px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
            </div>

            <div class="territory-details-section">
                <div class="detail-row" *ngFor="let i of [1,2,3,4,5,6,7]">
                    <span class="detail-label">
                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '14px', 'width': '50px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                    </span>
                    <span class="detail-value">
                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '14px', 'min-width': '50px','max-width': '80px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                    </span>
                </div>
            </div>

            <div class="territoriesLocations-section">
                <div class="search-Arrow-flex">
                    <div style="width: 90%; height: 40px; margin-bottom: 5px;">
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '40px', 'width': '100%', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                    </div>
                </div>

                <div class="territoriesLocations-list">
                    <div class="locationCard" *ngFor="let i of [1,2,3,4,5]">
                        <div class="locationCard-icon">
                            <ngx-skeleton-loader count="1" appearance="circle" [theme]="{ 'width': '28px', 'height': '28px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                        </div>
                        <div class="locationCard-info">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '14px', 'width': '120px', 'background-color': '#bdbdbd', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '12px', 'width': '100px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                        </div>
                        <div class="locationCard-delete">
                            <ngx-skeleton-loader count="1" appearance="circle" [theme]="{ 'width': '24px', 'height': '24px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>